import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUser from '../reducers/user.reducer';

export const selectUserState = createFeatureSelector<fromUser.State>(
  fromUser.userFeatureKey
);

export const selectCurrentPage = createSelector(
  selectUserState,
  (state: fromUser.State) => state.currentPage
);
